import React from "react";

function Impressum() {
    return (
        <div class="uk-container uk-padding">
            <div class="uk-text-left">
                <h2>Impressum</h2>
                <br></br>
                <div class="uk-margin-remove-top">
                    <p class="uk-margin-remove">Andrea Köhler</p>
                    <p class="uk-margin-remove">Rüschendamm 1</p>
                    <p class="uk-margin-remove">26655 Westerstede</p>
                    <br></br>
                    <p class="uk-margin-remove">Tel.: 044885204588</p>
                    <p class="uk-margin-remove">E-Mail: koehleran@web.de</p>
                </div>
                
                <br></br>
                <p>USt. wird nicht ausgewiesen, da die Verkäuferin Kleinunternehmerin im Sinne des UStG ist.</p>
                <p>Plattform der EU-Kommission zur Online-Streitbeilegung: https://ec.europa.eu/odr</p>
                <p>Ich bin zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht bereit und nicht verpflichtet.</p>
            </div>
        </div>
    );
}

export default Impressum;